import {
  FormSinistroSanitarioComponent
} from "../../../../civile/fascicoloFormShared/form-sinistro-sanitario/form-sinistro-sanitario.component";
import {
  FormOpposizioneAttiEsecutiviComponent
} from "../../../../civile/fascicoloFormShared/form-opposizione-atti-esecutivi/form-opposizione-atti-esecutivi.component";
import {
  FormOpposizioneAttiEsecutiviViewComponent
} from "../../../../civile/fascicoloFormShared/form-opposizione-atti-esecutivi/view/form-opposizione-atti-esecutivi-view.component";
import {
  FormNegoziazioneAssistitaComponent
} from "../../../../civile/fascicoloFormShared/form-negoziazione-assistita/form-negoziazione-assistita.component";
import {
  FascicoloAzioneRevocatoria
} from "../../../../civile/fascicoloFormShared/models/azione-revocatoria/fascicolo-azione-revocatoria";
import {
  FascicoloOpposizioneAttiEsecutivi
} from "../../../../civile/fascicoloFormShared/models/opposizione-atti-esecutivi/fascicolo-opposizione-atti-esecutivi";
import {
  FascicoloNegoziazioneAssistita
} from "../../../../civile/fascicoloFormShared/models/negoziazione-assistita/fascicolo-negoziazione-assistita";
import {
  FormAzioneRevocatoriaViewComponent
} from "../../../../civile/fascicoloFormShared/form-azione-revocatoria/view/form-azione-revocatoria-view.component";
import {
  FormNegoziazioneAssistitaViewComponent
} from "../../../../civile/fascicoloFormShared/form-negoziazione-assistita/view/form-negoziazione-assistita-view.component";
import {
  FascicoloOpposizionePrecetto
} from "../../../../civile/fascicoloFormShared/models/opposizione-precetto/fascicolo-opposizione-precetto";
import {
  FormOpposizionePrecettoViewComponent
} from "../../../../civile/fascicoloFormShared/form-opposizione-precetto/view/form-opposizione-precetto-view.component";
import {
  FormOpposizioneEsecuzioneViewComponent
} from "../../../../civile/fascicoloFormShared/form-opposizione-esecuzione/view/form-opposizione-esecuzione-view.component";
import {
  FormSinistroSanitarioViewComponent
} from "../../../../civile/fascicoloFormShared/form-sinistro-sanitario/view/form-sinistro-sanitario-view.component";
import {
  FascicoloSommarioUrgenza
} from "../../../../civile/fascicoloFormShared/models/sommario-urgenza/fascicolo-sommariourgenza";
import {
  FascicoloSinistroSanitario
} from "../../../../civile/fascicoloFormShared/models/sinistro-sanitario/fascicolo-sinistrosanitario";
import {
  FormOpposizioneEsecuzioneComponent
} from "../../../../civile/fascicoloFormShared/form-opposizione-esecuzione/form-opposizione-esecuzione.component";
import {
  FascicoloOpposizioneEsecuzione
} from "../../../../civile/fascicoloFormShared/models/opposizione-esecuzione/fascicolo-opposizione-esecuzione";
import {
  FormOpposizionePrecettoComponent
} from "../../../../civile/fascicoloFormShared/form-opposizione-precetto/form-opposizione-precetto.component";
import {
  FormSommarioUrgenzaViewComponent
} from "../../../../civile/fascicoloFormShared/form-sommario-urgenza/view/form-sommario-urgenza-view.component";
import {
  FormSommarioUrgenzaComponent
} from "../../../../civile/fascicoloFormShared/form-sommario-urgenza/form-sommario-urgenza.component";
import {
  FormAzioneRevocatoriaComponent
} from "../../../../civile/fascicoloFormShared/form-azione-revocatoria/form-azione-revocatoria.component";
import {
  FormOrdinarioViewComponent
} from "../../../../civile/fascicoloFormShared/form-ordinario/view/form-ordinario-view.component";
import {FormOrdinarioComponent} from "../../../../civile/fascicoloFormShared/form-ordinario/form-ordinario.component";
import {
  FormOpposizioneDecretoIngiuntivoViewComponent
} from "../../../../civile/fascicoloFormShared/form-opposizione-decreto-ingiuntivo/view/form-opposizione-decreto-ingiuntivo-view.component";
import {
  FormOpposizioneDecretoIngiuntivoComponent
} from "../../../../civile/fascicoloFormShared/form-opposizione-decreto-ingiuntivo/form-opposizione-decreto-ingiuntivo.component";
import {
  FormCautelareViewComponent
} from "../../../../civile/fascicoloFormShared/form-cautelare/view/form-cautelare-view.component";
import {FormCautelareComponent} from "../../../../civile/fascicoloFormShared/form-cautelare/form-cautelare.component";
import {
  FormSpecialeViewComponent
} from "../../../../civile/fascicoloFormShared/form-speciale/view/form-speciale-view.component";
import {FormSpecialeComponent} from "../../../../civile/fascicoloFormShared/form-speciale/form-speciale.component";
import {
  FormImmobiliareViewComponent
} from "../../../../civile/fascicoloFormShared/form-immobiliare/view/form-immobiliare-view.component";
import {
  FormImmobiliareComponent
} from "../../../../civile/fascicoloFormShared/form-immobiliare/form-immobiliare.component";
import {
  FormMobiliareViewComponent
} from "../../../../civile/fascicoloFormShared/form-mobiliare/view/form-mobiliare-view.component";
import {FormMobiliareComponent} from "../../../../civile/fascicoloFormShared/form-mobiliare/form-mobiliare.component";
import {
  FormCoterziViewComponent
} from "../../../../civile/fascicoloFormShared/form-coterzi/view/form-coterzi-view.component";
import {FormCoterziComponent} from "../../../../civile/fascicoloFormShared/form-coterzi/form-coterzi.component";
import {
  FormAzioneMonitoriaViewComponent
} from "../../../../civile/fascicoloFormShared/form-azione-monitoria/view/form-azione-monitoria-view.component";
import {
  FormAzioneMonitoriaComponent
} from "../../../../civile/fascicoloFormShared/form-azione-monitoria/form-azione-monitoria.component";
import {
  FormPrecettoViewComponent
} from "../../../../civile/fascicoloFormShared/form-precetto/view/form-precetto-view.component";
import {FormPrecettoComponent} from "../../../../civile/fascicoloFormShared/form-precetto/form-precetto.component";
import {
  FormArbitratoViewComponent
} from "../../../../civile/fascicoloFormShared/form-arbitrato/view/form-arbitrato-view.component";
import {FormArbitratoComponent} from "../../../../civile/fascicoloFormShared/form-arbitrato/form-arbitrato.component";
import {
  FormMediazioneViewComponent
} from "../../../../civile/fascicoloFormShared/form-mediazione/view/form-mediazione-view.component";
import {
  FormMediazioneComponent
} from "../../../../civile/fascicoloFormShared/form-mediazione/form-mediazione.component";
import {
  FormRecuperoCreditiStragiudizialeViewComponent
} from "../../../../civile/fascicoloFormShared/form-recupero-crediti-stragiudiziale/view/form-recupero-crediti-stragiudiziale-view.component";
import {
  FormRecuperoCreditiStragiudizialeComponent
} from "../../../../civile/fascicoloFormShared/form-recupero-crediti-stragiudiziale/form-recupero-crediti-stragiudiziale.component";
import {
  FormAmiantoViewComponent
} from "../../../../civile/fascicoloFormShared/form-amianto/view/form-amianto-view.component";
import {FormAmiantoComponent} from "../../../../civile/fascicoloFormShared/form-amianto/form-amianto.component";
import {
  FormAmiantoGiudizialeViewComponent
} from "../../../../civile/fascicoloFormShared/form-amianto-giudiziale/view/form-amianto-giudiziale-view.component";
import {
  FormAmiantoGiudizialeComponent
} from "../../../../civile/fascicoloFormShared/form-amianto-giudiziale/form-amianto-giudiziale.component";
import {
  FormRicorsoLavoroViewComponent
} from "../../../../civile/fascicoloFormShared/form-ricorso-lavoro/view/form-ricorso-lavoro-view.component";
import {
  FormRicorsoLavoroComponent
} from "../../../../civile/fascicoloFormShared/form-ricorso-lavoro/form-ricorso-lavoro.component";
import {
  FormEsecuzioneViewComponent
} from "../../../../civile/fascicoloFormShared/form-esecuzione/view/form-esecuzione-view.component";
import {
  FormEsecuzioneComponent
} from "../../../../civile/fascicoloFormShared/form-esecuzione/form-esecuzione.component";
import {
  FormRicorsoAmministrativoViewComponent
} from "../../../../civile/fascicoloFormShared/form-ricorso/view/form-ricorso-view.component";
import {
  FormRicorsoAmministrativoComponent
} from "../../../../civile/fascicoloFormShared/form-ricorso/form-ricorso.component";
import {FascicoloOrdinario} from "../../../../civile/fascicoloFormShared/models/ordinario/fascicolo-ordinario";
import {
  FascicoloOpposizioneDecretoIngiuntivo
} from "../../../../civile/fascicoloFormShared/models/opposizione-decreto-ingiuntivo/fascicolo-opposizione-decreto-ingiuntivo";
import {FascicoloCautelare} from "../../../../civile/fascicoloFormShared/models/cautelare/fascicolo-cautelare";
import {FascicoloSpeciale} from "../../../../civile/fascicoloFormShared/models/speciale/fascicolo-speciale";
import {FascicoloImmobiliare} from "../../../../civile/fascicoloFormShared/models/immobiliare/fascicolo-immobiliare";
import {FascicoloMobiliare} from "../../../../civile/fascicoloFormShared/models/mobiliare/fascicolo-mobiliare";
import {FascicoloCoTerzi} from "../../../../civile/fascicoloFormShared/models/coterzi/fascicolo-coterzi";
import {
  FascicoloAzioneMonitoria
} from "../../../../civile/fascicoloFormShared/models/azione-monitoria/fascicolo-azione-monitoria";
import {FascicoloPrecetto} from "../../../../civile/fascicoloFormShared/models/precetto/fascicolo-precetto";
import {FascicoloArbitrato} from "../../../../civile/fascicoloFormShared/models/arbitrato/fascicolo-arbitrato";
import {FascicoloMediazione} from "../../../../civile/fascicoloFormShared/models/mediazione/fascicolo-mediazione";
import {
  FascicoloRecuperoCreditiStragiudiziale
} from "../../../../civile/fascicoloFormShared/models/recupero-crediti-stragiudiziale/fascicolo-recuperocreditistragiudiziale";
import {FascicoloAmianto} from "../../../../civile/fascicoloFormShared/models/amianto/fascicolo-amianto";
import {
  FascicoloAmiantoGiudiziale
} from "../../../../civile/fascicoloFormShared/models/amianto-giudiziale/fascicolo-amianto-giudiziale";
import {
  FascicoloRicorsoLavoro
} from "../../../../civile/fascicoloFormShared/models/ricorso-lavoro/fascicolo-ricorso-lavoro";
import {FascicoloEsecuzione} from "../../../../civile/fascicoloFormShared/models/esecuzione/fascicolo-esecuzione";
import {
  FascicoloRicorsoAmministrativo
} from "../../../../amministrativa/fascicoloFormShared/models/ricorso/fascicolo-ricorso";
import { FascicoloGenerico } from "src/app/civile/fascicoloFormShared/models/generico/fascicolo-generico";
import { FormGenericoViewComponent } from "src/app/civile/fascicoloFormShared/form-generico/view/form-generico-view.component";
import { FormGenericoComponent } from "src/app/civile/fascicoloFormShared/form-generico/form-generico.component";

export function getComponentFromFormTenantCivile(idFormTenant, view = false) {
  switch (idFormTenant) {
    case 'CivOrd_PRD': {
      return view ? FormOrdinarioViewComponent : FormOrdinarioComponent; // "ORDINARIO";
    }
    case 'CivOdi_PRD': {
      return view ? FormOpposizioneDecretoIngiuntivoViewComponent : FormOpposizioneDecretoIngiuntivoComponent; // "OPPOSIZIONE AL DECRETO INGIUNTIVO";
    }
    case 'CivOpp_PRD': {
      return view ? FormOpposizioneDecretoIngiuntivoViewComponent : FormOpposizioneDecretoIngiuntivoComponent; // "OPPOSIZIONE AL DECRETO INGIUNTIVO";
    }
    case 'CivOae_PRD': {
      return view ? FormOpposizioneAttiEsecutiviViewComponent : FormOpposizioneAttiEsecutiviComponent; // "OPPOSIZIONE AGLI ATTI ESECUTIVI";
    }
    case 'CivOpr_PRD': {
      return view ? FormOpposizionePrecettoViewComponent : FormOpposizionePrecettoComponent; // "OPPOSIZIONE A PRECETTO";
    }
    case 'CivOes_PRD': {
      return view ? FormOpposizioneEsecuzioneViewComponent : FormOpposizioneEsecuzioneComponent; // "OPPOSIZIONE ALL'ESECUZIONE";
    }
    case 'CivCau_PRD': {
      return view ? FormCautelareViewComponent : FormCautelareComponent; // "CAUTELARE";
    }
    case 'CivSpe_PRD': {
      return view ? FormSpecialeViewComponent : FormSpecialeComponent; // "SPECIALE";
    }
    case 'CivSom_PRD': {
      return view ? FormSommarioUrgenzaViewComponent : FormSommarioUrgenzaComponent; // "SOMMARIO D'URGENZA";
    }
    case 'CivEim_PRD': {
      return view ? FormImmobiliareViewComponent : FormImmobiliareComponent; // "ESECUZIONE IMMOBILIARE";
    }
    case 'CivEmo_PRD': {
      return view ? FormMobiliareViewComponent : FormMobiliareComponent; // "ESECUZIONE MOBILIARE";
    }
    case 'CivEpt_PRD': {
      return view ? FormCoterziViewComponent : FormCoterziComponent; // "ESECUZIONE C/O TERZI";
    }
    case 'CivAzi_PRD': {
      return view ? FormAzioneMonitoriaViewComponent : FormAzioneMonitoriaComponent; // "AZIONE MONITORIA";
    }
    case 'CivPre_PRD': {
      return view ? FormPrecettoViewComponent : FormPrecettoComponent; // "PRECETTO";
    }
    case 'CivNeg_PRD': {
      return view ? FormNegoziazioneAssistitaViewComponent : FormNegoziazioneAssistitaComponent; // "NEGOZIAZIONE ASSISTITA";
    }
    case 'CivArb_PRD': {
      return view ? FormArbitratoViewComponent : FormArbitratoComponent; // "ARBRITATO";
    }
    case 'CivMed_PRD': {
      return view ? FormMediazioneViewComponent : FormMediazioneComponent; // "MEDIAZIONE";
    }
    case 'CivRec_PRD': {
      return view ? FormRecuperoCreditiStragiudizialeViewComponent : FormRecuperoCreditiStragiudizialeComponent; // "RECUPERO CREDITI STRAGIUDIZIALE";
    }
    case 'CivSan_PRD': {
      return view ? FormSinistroSanitarioViewComponent : FormSinistroSanitarioComponent; // "SINISTRO SANITARIO";
    }
    case 'CivAmi_PRD': {
      return view ? FormAmiantoViewComponent : FormAmiantoComponent;
    }
    case 'CivAmg_PRD': {
      return view ? FormAmiantoGiudizialeViewComponent : FormAmiantoGiudizialeComponent;
    }
    case 'CivRla_PRD': {
      return view ? FormRicorsoLavoroViewComponent : FormRicorsoLavoroComponent;
    }
    case 'CivArv_PRD': {
      return view ? FormAzioneRevocatoriaViewComponent : FormAzioneRevocatoriaComponent;
    }
    case 'CivEse_PRD': {
      return view ? FormEsecuzioneViewComponent : FormEsecuzioneComponent;
    }
    case 'CivRam_PRD': {
      return view ? FormRicorsoAmministrativoViewComponent : FormRicorsoAmministrativoComponent;
    }
    case 'CivGen_PRD': {
      return view ? FormGenericoViewComponent : FormGenericoComponent;
    }
  }
}

export function getFascicoloCivile(genericFascicolo): any {
  let fascicolo;
  switch (genericFascicolo) {
    case 'ordinario': {
      fascicolo = new FascicoloOrdinario();
      break;
    }
    case 'opposizionedecretoingiuntivo': {
      fascicolo = new FascicoloOpposizioneDecretoIngiuntivo();
      break;
    }
    case 'opposizioneattiesecutivi': {
      fascicolo = new FascicoloOpposizioneAttiEsecutivi();
      break;
    }
    case 'opposizioneprecetto': {
      fascicolo = new FascicoloOpposizionePrecetto();
      break;
    }
    case 'opposizioneesecuzione': {
      fascicolo = new FascicoloOpposizioneEsecuzione();
      break;
    }
    case 'opposizione': {
      fascicolo = new FascicoloOpposizioneDecretoIngiuntivo();
    }
    case 'cautelare': {
      fascicolo = new FascicoloCautelare();
      break;
    }
    case 'speciale': {
      fascicolo = new FascicoloSpeciale();
      break;
    }
    case 'sommariourgenza': {
      fascicolo = new FascicoloSommarioUrgenza();
      break;
    }
    case 'esecuzioneimmobiliare': {
      fascicolo = new FascicoloImmobiliare();
      break;
    }
    case 'esecuzionemobiliare': {
      fascicolo = new FascicoloMobiliare();
      break;
    }
    case 'esecuzionepressoterzi': {
      fascicolo = new FascicoloCoTerzi();
      break;
    }
    case 'azionemonitoria': {
      fascicolo = new FascicoloAzioneMonitoria();
      break;
    }
    case 'precetto': {
      fascicolo = new FascicoloPrecetto();
      break;
    }
    case 'arbitrato': {
      fascicolo = new FascicoloArbitrato();
      break;
    }
    case 'mediazione': {
      fascicolo = new FascicoloMediazione();
      break;
    }
    case 'recuperocreditistragiudiziale': {
      fascicolo = new FascicoloRecuperoCreditiStragiudiziale();
      break;
    }
    case 'negoziazione': {
      fascicolo = new FascicoloNegoziazioneAssistita();
      break;
    }
    case 'sinistrosanitario': {
      fascicolo = new  FascicoloSinistroSanitario();
      break;
    }
    case 'amianto': {
      fascicolo = new FascicoloAmianto();
      break;
    }
    case 'amiantogiudiziale': {
      fascicolo = new FascicoloAmiantoGiudiziale();
      break;
    }
    case 'ricorso':
    case 'ricorsolavoro': {
      fascicolo = new FascicoloRicorsoLavoro();
      break;
    }
    case 'azionerevocatoria': {
      fascicolo = new FascicoloAzioneRevocatoria();
      break;
    }
    case 'esecuzione': {
      fascicolo = new FascicoloEsecuzione();
      break;
    }
    case 'ricorsoamministrativo':
    case 'ricorsotar': {
      fascicolo = new FascicoloRicorsoAmministrativo();
      break;
    }
    case 'genericogiudiziale': {
      fascicolo = new FascicoloGenerico();
      break;
    }
  }
  return fascicolo;
}
